import { createAppConfigFromEnv } from '@elva/platform';

export const frontdeskPlatformConfig = createAppConfigFromEnv(import.meta.env, {
  appName: 'Elva FrontDesk',
  tokenKey: 'elva_auth_token',
  loginCallbackPath: '/loginok',
  publicPathPrefix: '/public',
  extraPublicPaths: ['/treatment', '/invisalign'],
});
